module.exports = __webpack_public_path__ + "img/eucalyptus_cinerea.b7dce23e.jpg";